module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "endangered-species"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "species"
  }, _vm._l((_vm.species), function(animal) {
    return _c('p', {
      key: animal,
      staticClass: "animal"
    }, [_vm._v("\n        " + _vm._s(animal) + "\n      ")])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "habitat-destruction"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Ways you can make a difference with habitat destruction")])]), _vm._v(" "), _c('div', {
    staticClass: "differences"
  }, [_c('div', {
    staticClass: "difference"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/img-help-wildlife-neighbourhood.jpeg",
      "alt": "picture"
    }
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.wwf.org.au/news/blogs/9-australian-native-plants-and-trees-to-attract-wildlife-and-bees-to-your-apartment-balcony-or-garden",
      "target": "_blank"
    }
  }, [_vm._v("Plant native trees")]), _vm._v("\n          and shurbs to create a wildlife-friendly oasis.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "difference"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/img-plant-trees.jpeg",
      "alt": "picture"
    }
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.wwf.org.au/news/blogs/10-easy-ways-you-can-help-wildlife-right-now",
      "target": "_blank"
    }
  }, [_vm._v("Learn easy tips")]), _vm._v("\n          on how you can help wildlife in your neighbourhood.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "difference"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/img-scat-chat-with-wwf-1000px.jpg",
      "alt": "picture"
    }
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.wwf.org.au/get-involved/scat-chat",
      "target": "_blank"
    }
  }, [_vm._v("Tune into Scat Chat")]), _vm._v("\n          to get to the bottom of amazing things animal scat (or poo) can\n          teach us about the environment. Hosted by comedian Carlo Ritchie.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Other animals at risk of extinction in your area:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1507c472","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/threatened-species/Other.vue
// module id = 754
// module chunks = 0